module.exports = __webpack_public_path__ + "img/icn_brand16.64b5624f.svg";